import { ButtonSocialVariant } from './ButtonSocial.types';
import FACEBOOK_SRC from './_assets/facebook.svg';
import GOOGLE_SRC from './_assets/google.svg';
import APPLE_SRC from './_assets/apple.svg';

export const BUTTON_SOCIAL_TYPE_FILL: Record<
  ButtonSocialVariant,
  'outline' | 'solid'
> = {
  facebook: 'solid',
  google: 'outline',
  apple: 'solid',
};

export const BUTTON_SOCIAL_TYPE_IMAGE: Record<ButtonSocialVariant, string> = {
  facebook: FACEBOOK_SRC,
  google: GOOGLE_SRC,
  apple: APPLE_SRC,
};
